import React from 'react'
import { useIntl } from 'react-intl'
import { BigButtonSection } from '../../../../components/layout'
import { Styling } from '../../../../components/Styling'
import { SaveButton } from './SaveButton'
import { TowingOrderSaveButtonsProps } from './types'

export const MainUserButtons: React.FC<TowingOrderSaveButtonsProps> = ({ userId, operatorId, handleSubmit }) => {
  const { formatMessage } = useIntl()
  const unAssigned = operatorId == null
  const assignToSelf = operatorId === userId
  const assignToOther = operatorId && operatorId !== userId
  return (
    <BigButtonSection justifyContent="end">
      <>
        {unAssigned && (
          <>
            <SaveButton onClick={() => handleSubmit(false, null, 'open')}>
              <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.save' })}</Styling>
              <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.openToAll' })}</Styling>
            </SaveButton>

            <SaveButton onClick={() => handleSubmit(false, null, 'restricted')}>
              <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.save' })}</Styling>
              <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.openToMainUsers' })}</Styling>
            </SaveButton>
            <SaveButton onClick={() => handleSubmit(false, userId, 'assigned')}>
              <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.saveAnd' })}</Styling>
              <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.acceptToSelf' })}</Styling>
            </SaveButton>
          </>
        )}
        {assignToSelf && (
          <SaveButton onClick={() => handleSubmit(false, userId, 'assigned')}>
            <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.saveAnd' })}</Styling>
            <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.acceptToSelf' })}</Styling>
          </SaveButton>
        )}
        {assignToOther && (
          <SaveButton onClick={() => handleSubmit(false, operatorId, 'assigned')}>
            <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.saveAnd' })}</Styling>
            <Styling fontSize="m">{formatMessage({ id: 'towingOrder.saveButtons.assignToOperator' })}</Styling>
          </SaveButton>
        )}
      </>
    </BigButtonSection>
  )
}
